(()=>{
  'use strict';
  function ready(fn){ if(document.readyState!=='loading'){ fn(); } else { document.addEventListener('DOMContentLoaded', fn); } }
  ready(()=>{
    // Parallax bg
    const bg = document.querySelector('.pb-hero-bg');
    if (bg){
      const onScroll = ()=>{
        const y = window.scrollY * 0.3;
        bg.style.backgroundPosition = `center calc(50% + ${y}px)`;
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }
    // Typewriter
    const el = document.querySelector('.pb-type');
    if (el){
      const parts = (el.getAttribute('data-type')||'').split('|').map(s=>s.trim());
      let idx = 0, pos = 0, dir = 1;
      function tick(){
        const text = parts[idx] || '';
        pos += dir;
        if (pos >= text.length){ dir = -1; setTimeout(tick, 1200); return; }
        if (pos <= 0){ dir = 1; idx = (idx+1)%parts.length; }
        el.textContent = text.substring(0,pos);
        setTimeout(tick, dir>0 ? 50 : 30);
      }
      setTimeout(tick, 300);
    }
    // Stats counter
    document.querySelectorAll('.pb-stat strong[data-count]').forEach((s)=>{
      const target = parseInt(s.getAttribute('data-count')||'0',10) || 0;
      let cur = 0; const step = Math.max(1, Math.round(target/60));
      const loop = ()=>{ cur += step; if (cur>target) cur=target; s.textContent = cur.toString(); if (cur<target) requestAnimationFrame(loop); };
      requestAnimationFrame(loop);
    });
  });
})();

